import { useContext } from 'react';
import { Feature } from '@shinetools/pricing-plan-library';

import { useCurrentPricingPlan } from '../useCurrentPricingPlan';
import useFeatureFlagsSwitcher from '../useFeatureFlagsSwitcher';
import { canAccessMultiWalletContext } from './canAccessMultiWalletContext';

export const useMultiWalletFeature = () => {
  const { featureFlags } = useFeatureFlagsSwitcher();
  const { canAccessMultiWallet } = useContext(canAccessMultiWalletContext);
  const { isFeatureAvailable } = useCurrentPricingPlan();

  const isFeatureAvailableForCompanyPlan = isFeatureAvailable(
    Feature.MultiWallet,
  );

  return {
    canAccessMultiWalletPrivateRelease:
      (featureFlags.enableMultiWalletPrivateRelease ||
        featureFlags.enableMultiWalletPublicRelease ||
        canAccessMultiWallet) &&
      isFeatureAvailableForCompanyPlan,
    canAccessMultiWalletPublicRelease:
      featureFlags.enableMultiWalletPublicRelease || canAccessMultiWallet,
    isMultiWalletFeatureAvailableForCompanyPlan:
      isFeatureAvailableForCompanyPlan,
  };
};
